import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import AirportShuttleIcon from "@material-ui/icons/AirportShuttle";
import ArchiveIcon from "@material-ui/icons/Archive";
import AssessmentIcon from "@material-ui/icons/Assessment";
import AssignmentIcon from "@material-ui/icons/Assignment";
import BuildIcon from "@material-ui/icons/Build";
import BusinessIcon from "@material-ui/icons/Business";
import CategoryIcon from "@material-ui/icons/Category";
import DevicesOtherIcon from "@material-ui/icons/DevicesOther";
import DirectionsBoatIcon from "@material-ui/icons/DirectionsBoat";
import DoneIcon from "@material-ui/icons/Done";
import DonutSmallIcon from "@material-ui/icons/DonutSmall";
import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import FaceIcon from "@material-ui/icons/Face";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import GavelIcon from "@material-ui/icons/Gavel";
import GetAppIcon from "@material-ui/icons/GetApp";
import GroupIcon from "@material-ui/icons/Group";
import LanguageIcon from "@material-ui/icons/Language";
import ListAltIcon from "@material-ui/icons/ListAlt";
import MoneyIcon from "@material-ui/icons/Money";
import NotificationsIcon from "@material-ui/icons/Notifications";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import ReceiptIcon from "@material-ui/icons/Receipt";
import RoomServiceIcon from "@material-ui/icons/RoomService";
import SearchIcon from "@material-ui/icons/Search";
import SettingsIcon from "@material-ui/icons/Settings";
import SmsFailedIcon from "@material-ui/icons/SmsFailed";
import SpeakerPhoneIcon from "@material-ui/icons/SpeakerPhone";
import StoreIcon from "@material-ui/icons/Store";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import AdminLogin from "../AdminTools/AdminLogin";
import ControlPanel from "../AdminTools/ControlPanel";
import DeviceModule from "../AdminTools/DeviceModule";
import AdminDevices from "../AdminTools/DeviceModule/AdminDevices";
import Transfers from "../AdminTools/LifeCycleManagementModule/Transfers";
import MaintenanceModule from "../AdminTools/MaintenanceModule";
import MaintenanceTickets from "../AdminTools/MaintenanceModule/MaintenanceTickets";
import TicketArchive from "../AdminTools/MaintenanceModule/MaintenanceTickets/TicketArchive";
import MaintenanceStatistics from "../AdminTools/MaintenanceModule/Statistics";
import TicketSettings from "../AdminTools/MaintenanceModule/TicketSettings";
import ServiceItemModule from "../AdminTools/ServiceItemModule";
import SoftwareDetails from "../AdminTools/SoftwareModule";
import CrashlogDetails from "../AdminTools/SoftwareModule/CrashlogDetails";
import Crashlogs from "../AdminTools/SoftwareModule/Crashlogs";
import Releases from "../AdminTools/SoftwareModule/Releases";
import PrereleaseList from "../AdminTools/SoftwareModule/Releases/PrereleaseList";
import ReleaseList from "../AdminTools/SoftwareModule/Releases/ReleaseList";
import StockModule from "../AdminTools/StockModule";
import ModifyStock from "../AdminTools/StockModule/ModifyStock";
import StockStatistics from "../AdminTools/StockModule/StockStatistics";
import SystemDashboard from "../AdminTools/SystemModule";
import EmailLists from "../AdminTools/SystemModule/EmailLists";
import EditEmailList from "../AdminTools/SystemModule/EmailLists/EditEmailList";
import NewEmailList from "../AdminTools/SystemModule/EmailLists/NewEmailList";
import NewUser from "../AdminTools/SystemModule/NewUser";
import Users from "../AdminTools/SystemModule/Users";
import EditUser from "../AdminTools/SystemModule/Users/EditUser";
import TaskModule from "../AdminTools/TaskModule";
import WebstoreOrders from "../AdminTools/WebstoreOrders";
import EditWebstoreOrder from "../AdminTools/WebstoreOrders/EditWebstoreOrder";
import { USER_GROUPS, checkRequiredPermissions } from "../Utils/Common";
import Alerts from "../Views/Alerts";
import AlertView from "../Views/Alerts/Alert";
import ChangePassword from "../Views/ChangePassword";
import Contacts from "../Views/Contacts";
import Contact from "../Views/Contacts/Contact";
import Dashboard from "../Views/Dashboard";
import DemoDevices from "../Views/DemoDevices";
import DeviceDetails from "../Views/DeviceDetails";
import Devices from "../Views/Devices";
import DispatchedDevices from "../Views/DispatchedDevices";
import Login from "../Views/Login";
import Manufacturing from "../Views/Manufacturing";
import ManufacturingFeatureLists from "../Views/Manufacturing/Features";
import FeatureItems from "../Views/Manufacturing/Features/FeatureItems";
import ManufacturingOrders from "../Views/Manufacturing/Orders";
import ManufacturingRecipes from "../Views/Manufacturing/Recipes";
import SerialisedSubAssemblies from "../Views/Manufacturing/SerialisedSubAssemblies";
import Orders from "../Views/Orders";
import ProductTransfers from "../Views/ProductTransfers";
import Production from "../Views/Production";
import ResupplyOrders from "../Views/ResupplyOrders";
import SupplierCompanies from "../Views/ResupplyOrders/SupplierCompanies";
import EditSupplierCompany from "../Views/ResupplyOrders/SupplierCompanies/EditCompany";
import SendPasswordReset from "../Views/SendPasswordReset";
import SessionDetails from "../Views/SessionDetails";
import Settings from "../Views/Settings";
import Shipments from "../Views/Shipments";
import ShippingCompanies from "../Views/Shipments/ShippingCompanies";
import EditCompany from "../Views/Shipments/ShippingCompanies/EditCompany";
import WorldMap from "../Views/WorldMap";
// Titles are translation keys. Component getters defer reads until rendering,
// since dashboard pages also consume this registry for their navigation.
// Route order is significant: specific paths must precede their parent paths.

export const adminRouteConfig = {
  alertsAlertId: {
    path: "/cpanel/alerts/:alert_id",

    get component() {
      return AlertView;
    },
  },
  alerts: {
    path: "/cpanel/alerts",

    get component() {
      return Alerts;
    },

    title: "alerts.header",
    icon: NotificationsIcon,
  },
  contactsTypeId: {
    path: "/cpanel/contacts/:type/:id",

    get component() {
      return Contact;
    },
  },
  contacts: {
    path: "/cpanel/contacts",

    get component() {
      return Contacts;
    },

    title: "contacts.header",
    icon: BusinessIcon,
  },
  usersNew: {
    path: "/cpanel/users/new",

    get component() {
      return NewUser;
    },

    superuser: true,
    title: "users.newUser",
    icon: PersonAddIcon,
  },
  usersId: {
    path: "/cpanel/users/:id",

    get component() {
      return EditUser;
    },

    superuser: true,
  },
  users: {
    path: "/cpanel/users",

    get component() {
      return Users;
    },

    superuser: true,
    title: "adminSideBar.users",
    icon: GroupIcon,
  },
  crashlogsCrashlogId: {
    path: "/cpanel/crashlogs/:crashlog_id",

    get component() {
      return CrashlogDetails;
    },
  },
  crashlogs: {
    path: "/cpanel/crashlogs",

    get component() {
      return Crashlogs;
    },

    title: "deviceDetails.crashLogs",
    icon: SmsFailedIcon,
  },
  devicesDashboard: {
    path: "/cpanel/devices/dashboard",

    get component() {
      return DeviceModule;
    },

    title: "devices.header",
    icon: DevicesOtherIcon,
  },
  devicesDeviceId: {
    path: "/cpanel/devices/:device_id",

    get component() {
      return DeviceDetails;
    },
  },
  devices: {
    path: "/cpanel/devices",

    get component() {
      return AdminDevices;
    },

    title: "search",
    icon: SearchIcon,
  },
  demos: {
    path: "/cpanel/demos",

    get component() {
      return DemoDevices;
    },

    title: "mainSideBar.demos",
    icon: EmojiTransportationIcon,
  },
  dispatches: {
    path: "/cpanel/dispatches",

    get component() {
      return DispatchedDevices;
    },

    title: "mainSideBar.dispatches",
    icon: DoneIcon,
  },
  emaillistsNew: {
    path: "/cpanel/emaillists/new",

    get component() {
      return NewEmailList;
    },

    superuser: true,
    title: "emailLists.newList",
    icon: PlaylistAddIcon,
  },
  emaillistsListId: {
    path: "/cpanel/emaillists/:list_id",

    get component() {
      return EditEmailList;
    },

    superuser: true,
  },
  emaillists: {
    path: "/cpanel/emaillists",

    get component() {
      return EmailLists;
    },

    superuser: true,
  },
  maintenanceTicketarchive: {
    path: "/cpanel/maintenance/ticketarchive",

    get component() {
      return TicketArchive;
    },

    title: "maintenance.ticketArchive",
    icon: DoneIcon,
  },
  maintenanceTickets: {
    path: "/cpanel/maintenance/tickets",

    get component() {
      return MaintenanceTickets;
    },

    title: "maintenance.activeTickets",
    icon: BuildIcon,
  },
  maintenanceStatistics: {
    path: "/cpanel/maintenance/statistics",

    get component() {
      return MaintenanceStatistics;
    },

    title: "maintenance.statistics",
    icon: AssessmentIcon,
  },
  maintenanceSettings: {
    path: "/cpanel/maintenance/settings",

    get component() {
      return TicketSettings;
    },

    superuser: true,
    title: "maintenance.settings",
    icon: SettingsIcon,
  },
  maintenanceTasks: {
    path: "/cpanel/maintenance/tasks",
    redirectionTo: () => "/cpanel/tasks",
  },
  maintenance: {
    path: "/cpanel/maintenance",

    get component() {
      return MaintenanceModule;
    },

    title: "maintenance.header",
    icon: BuildIcon,
  },
  manufacturingSerialisedsubassemblies: {
    path: "/cpanel/manufacturing/serialisedsubassemblies",

    get component() {
      return SerialisedSubAssemblies;
    },

    title: "manufacturing.serialisedSubAssemblies",
    icon: MoneyIcon,
  },
  manufacturingFeaturesItems: {
    path: "/cpanel/manufacturing/features/items",

    get component() {
      return FeatureItems;
    },
  },
  manufacturingFeatures: {
    path: "/cpanel/manufacturing/features",

    get component() {
      return ManufacturingFeatureLists;
    },

    title: "manufacturing.featureLists",
    icon: CategoryIcon,
  },
  manufacturingRecipes: {
    path: "/cpanel/manufacturing/recipes",

    get component() {
      return ManufacturingRecipes;
    },

    title: "manufacturing.recipes",
    icon: FormatListBulletedIcon,
  },
  manufacturingOrders: {
    path: "/cpanel/manufacturing/orders",

    get component() {
      return ManufacturingOrders;
    },

    title: "manufacturing.orders",
    icon: ReceiptIcon,
  },
  manufacturing: {
    path: "/cpanel/manufacturing",

    get component() {
      return Manufacturing;
    },

    title: "manufacturing.header",
    icon: GavelIcon,
  },
  ordersOrderId: {
    path: "/cpanel/orders/:order_id",

    get component() {
      return Orders;
    },
  },
  orders: {
    path: "/cpanel/orders",

    get component() {
      return Orders;
    },

    title: "orders.header",
    icon: ReceiptIcon,
  },
  production: {
    path: "/cpanel/production",
    sidebarTitle: "mainSideBar.production",
    sidebarIcon: ListAltIcon,

    get component() {
      return Production;
    },

    title: "lifeCycleManagement.header",
    icon: DonutSmallIcon,
  },
  resupplyordersOrderId: {
    path: "/cpanel/resupplyorders/:order_id",
    redirectionTo: (redirection) =>
      redirection.replace("resupplyorders", "resupply"),
  },
  resupplySuppliersId: {
    path: "/cpanel/resupply/suppliers/:id",

    get component() {
      return EditSupplierCompany;
    },
  },
  resupplySuppliers: {
    path: "/cpanel/resupply/suppliers",

    get component() {
      return SupplierCompanies;
    },

    title: "resupplyOrders.supplierCompanies",
    icon: BusinessIcon,
  },
  resupplyOrderId: {
    path: "/cpanel/resupply/:order_id",

    get component() {
      return ResupplyOrders;
    },
  },
  resupply: {
    path: "/cpanel/resupply",

    get component() {
      return ResupplyOrders;
    },

    title: "resupplyOrders.header",
    icon: AddShoppingCartIcon,
  },
  sessionsSessionId: {
    path: "/cpanel/sessions/:session_id",

    get component() {
      return SessionDetails;
    },
  },
  settings: {
    path: "/cpanel/settings",

    get component() {
      return Settings;
    },

    title: "mainSideBar.settings",
    icon: FaceIcon,
  },
  softwarePrereleasesDevice: {
    path: "/cpanel/software/prereleases/:device",

    get component() {
      return PrereleaseList;
    },

    superuser: true,
  },
  softwareReleasesDevice: {
    path: "/cpanel/software/releases/:device",

    get component() {
      return ReleaseList;
    },
  },
  softwareReleases: {
    path: "/cpanel/software/releases",

    get component() {
      return Releases;
    },
    title: "software.releases",
    icon: GetAppIcon,
  },
  software: {
    path: "/cpanel/software",

    get component() {
      return SoftwareDetails;
    },
    title: "software.header",
    icon: ArchiveIcon,
  },
  shipmentsNewOrderOrderId: {
    path: "/cpanel/shipments/new/order/:order_id",

    get component() {
      return Shipments;
    },
  },
  shipmentsNewResupplyResupplyOrderId: {
    path: "/cpanel/shipments/new/resupply/:resupply_order_id",

    get component() {
      return Shipments;
    },
  },
  shipmentsCompaniesId: {
    path: "/cpanel/shipments/companies/:id",

    get component() {
      return EditCompany;
    },
  },
  shipmentsCompanies: {
    path: "/cpanel/shipments/companies",

    get component() {
      return ShippingCompanies;
    },

    title: "shipments.shippingCompanies",
    icon: BusinessIcon,
  },
  shipmentsShipmentId: {
    path: "/cpanel/shipments/:shipment_id",

    get component() {
      return Shipments;
    },
  },
  shipments: {
    path: "/cpanel/shipments",

    get component() {
      return Shipments;
    },

    title: "shipments.header",
    icon: DirectionsBoatIcon,
  },
  stockStatistics: {
    path: "/cpanel/stock/statistics",

    get component() {
      return StockStatistics;
    },

    title: "stockModule.stockStatistics",
    icon: AssessmentIcon,
  },
  stockModify: {
    path: "/cpanel/stock/modify",

    get component() {
      return ModifyStock;
    },

    title: "stockModule.modifyStock",
    icon: SpeakerPhoneIcon,
  },
  stock: {
    path: "/cpanel/stock",

    get component() {
      return StockModule;
    },

    title: "stock.header",
    icon: EqualizerIcon,
  },
  serviceitems: {
    path: "/cpanel/serviceitems",

    get component() {
      return ServiceItemModule;
    },

    superuser: true,
    title: "serviceItemsModule.header",
    icon: RoomServiceIcon,
  },
  system: {
    path: "/cpanel/system",

    get component() {
      return SystemDashboard;
    },

    superuser: true,
    title: "system.header",
    icon: SettingsIcon,
  },
  tasks: {
    path: "/cpanel/tasks",

    get component() {
      return TaskModule;
    },

    title: "tasks.header",
    icon: AssignmentIcon,
  },
  transferlist: {
    path: "/cpanel/transferlist",

    get component() {
      return Transfers;
    },

    title: "transferList.header",
    icon: SyncAltIcon,
  },
  transfers: {
    path: "/cpanel/transfers",

    get component() {
      return ProductTransfers;
    },

    title: "mainSideBar.transfers",
    icon: AirportShuttleIcon,
  },
  webstoreOrderId: {
    path: "/cpanel/webstore/:order_id",

    get component() {
      return EditWebstoreOrder;
    },
  },
  webstore: {
    path: "/cpanel/webstore",

    get component() {
      return WebstoreOrders;
    },

    title: "webstoreOrders.header",
    icon: StoreIcon,
  },
  worldmap: {
    path: "/cpanel/worldmap",

    get component() {
      return WorldMap;
    },

    title: "mainSideBar.worldmap",
    icon: LanguageIcon,
  },
  controlPanel: {
    path: "/cpanel",

    get component() {
      return ControlPanel;
    },
  },
};
export const adminRoutes = Object.values(adminRouteConfig);
export const privateRoutes = [
  {
    path: "/worldmap",

    get component() {
      return WorldMap;
    },
  },
  {
    path: "/dashboard",

    get component() {
      return Dashboard;
    },
  },
  {
    path: "/devices/:device_id",

    get component() {
      return DeviceDetails;
    },
  },
  {
    path: "/devices",

    get component() {
      return Devices;
    },
  },
  {
    path: "/production",

    get component() {
      return Production;
    },

    get permissionRequirements() {
      return {
        permissionlevels: [
          USER_GROUPS.ADMIN,
          USER_GROUPS.PRODUCTION,
          USER_GROUPS.SALES,
        ],
      };
    },
  },
  {
    path: "/manufacturing/orders",

    get component() {
      return ManufacturingOrders;
    },

    get permissionRequirements() {
      return {
        permissionlevels: [USER_GROUPS.ADMIN, USER_GROUPS.PRODUCTION],
      };
    },
  },
  {
    path: "/manufacturing",

    get component() {
      return Manufacturing;
    },

    get permissionRequirements() {
      return {
        permissionlevels: [USER_GROUPS.ADMIN, USER_GROUPS.PRODUCTION],
      };
    },
  },
  {
    path: "/contacts/:type/:id",

    get component() {
      return Contact;
    },

    get permissionRequirements() {
      return {
        permissionlevels: [USER_GROUPS.ADMIN, USER_GROUPS.SALES],
      };
    },
  },
  {
    path: "/contacts",

    get component() {
      return Contacts;
    },

    get permissionRequirements() {
      return {
        permissionlevels: [USER_GROUPS.ADMIN, USER_GROUPS.SALES],
      };
    },
  },
  {
    path: "/sessions/:session_id",

    get component() {
      return SessionDetails;
    },
  },
  {
    path: "/settings",

    get component() {
      return Settings;
    },
  },
  {
    path: "/transfers",

    get component() {
      return ProductTransfers;
    },

    get permissionRequirements() {
      return {
        permissionlevels: [USER_GROUPS.ADMIN, USER_GROUPS.SALES],
      };
    },
  },
  {
    path: "/demos",

    get component() {
      return DemoDevices;
    },

    get permissionRequirements() {
      return {
        permissionlevels: [USER_GROUPS.ADMIN, USER_GROUPS.SALES],
      };
    },
  },
  {
    path: "/dispatches",

    get component() {
      return DispatchedDevices;
    },

    get permissionRequirements() {
      return {
        permissionlevels: [USER_GROUPS.ADMIN, USER_GROUPS.SALES],
      };
    },
  },
  {
    path: "/orders",

    get component() {
      return Orders;
    },

    get permissionRequirements() {
      return {
        permissionlevels: [USER_GROUPS.ADMIN],
      };
    },
  },
];
export const publicRoutes = [
  {
    path: "/reset_password/:token",

    get component() {
      return ChangePassword;
    },
  },
  {
    path: "/renew_password",

    get component() {
      return SendPasswordReset;
    },
  },
  {
    path: "/reset_password",

    get component() {
      return SendPasswordReset;
    },
  },
  {
    path: "/admin_login/:redirection_path",

    get component() {
      return AdminLogin;
    },
  },
  {
    path: "/admin_login",

    get component() {
      return AdminLogin;
    },
  },
  {
    path: "/login/:redirection_path",

    get component() {
      return Login;
    },
  },
  {
    path: "/login",

    get component() {
      return Login;
    },
  },
]; // Navigation groups reference stable route IDs; they never duplicate access flags.

export const adminModules = {
  ContactsModule: {
    route: "contacts",
  },
  DevicesModule: {
    route: "devicesDashboard",
    children: ["devices", "worldmap"],
  },
  LifeCycleModule: {
    route: "production",
    link: false,
    children: [
      "production",
      "transferlist",
      "transfers",
      "demos",
      "dispatches",
    ],
  },
  MaintenanceModule: {
    route: "maintenance",
    children: [
      "maintenanceTickets",
      "maintenanceTicketarchive",
      "maintenanceStatistics",
      "maintenanceSettings",
      "alerts",
    ],
  },
  ManufacturingModule: {
    route: "manufacturing",
    children: [
      "manufacturingOrders",
      "manufacturingRecipes",
      "manufacturingFeatures",
      "manufacturingSerialisedsubassemblies",
    ],
  },
  OrdersModule: {
    route: "orders",
  },
  ResupplysModule: {
    route: "resupply",
    children: ["resupplySuppliers"],
  },
  ShipmentsModule: {
    route: "shipments",
    children: ["shipmentsCompanies"],
  },
  ServiceItemModule: {
    route: "serviceitems",
    plain: true,
  },
  SoftwareModule: {
    route: "software",
    children: ["crashlogs", "softwareReleases"],
  },
  StockModule: {
    route: "stock",
    children: ["stockModify", "stockStatistics"],
  },
  SystemModule: {
    route: "system",
    children: ["users", "settings"],
  },
  TaskModule: {
    route: "tasks",
  },
  WebstoreModule: {
    route: "webstore",
  },
};
export const navigationRoutes = {
  emailLists: ["emaillistsNew"],
  users: ["usersNew"],
  resupply: ["resupplySuppliers"],
  shipments: ["shipmentsCompanies"],
  stock: ["stockModify", "stockStatistics"],
  manufacturing: [
    "manufacturingRecipes",
    "manufacturingOrders",
    "manufacturingFeatures",
    "manufacturingSerialisedsubassemblies",
  ],
  controlPanel: [
    "tasks",
    "software",
    "devicesDashboard",
    "production",
    "maintenance",
    "manufacturing",
    "serviceitems",
    "contacts",
    "system",
    "stock",
    "orders",
    "resupply",
    "webstore",
    "shipments",
  ],
  maintenance: [
    "maintenanceTicketarchive",
    "maintenanceTickets",
    "maintenanceStatistics",
    "maintenanceSettings",
    "alerts",
  ],
};
export function getAdminRoute(id) {
  return adminRouteConfig[id];
}
export function canAccessAdminRoute(route) {
  return (
    Boolean(route) &&
    checkRequiredPermissions([
      route.superuser ? USER_GROUPS.SUPER_USER : USER_GROUPS.ADMIN,
    ])
  );
}
export function getNavigationRoutes(section) {
  return (navigationRoutes[section] || [])
    .map(getAdminRoute)
    .filter(canAccessAdminRoute);
}

// Public registry for routes and the navigation surfaces that consume them.

export const routeConfig = {
  admin: adminRouteConfig,
  private: privateRoutes,
  public: publicRoutes,
  modules: adminModules,
  navigation: navigationRoutes,
};
